$(document).ready(function() {
    var x = $('.js-timeline');
    //console.log(x);
    ScrollReveal().reveal(x, {
        interval: 400,
        reset: true,
        distance: '500px',
        duration: 500
    });
    ScrollReveal().reveal('.js-timeline-left', {
        origin: 'left'
    });
    ScrollReveal().reveal('.js-timeline-right', {
        origin: 'right'
    });
});